<template>
  <div :class='["input-item-box",focused ?"input-item-box-focus":"" , !passValidate ? "error-border":""]' @click="focusInput" v-clickoutside="closeMenu">
    <span class="input-item-content-box">
      <span :class='["input-item-checked",deleteFlag &&index==checkedTagArr.length-1 ? "inputitem-delete":"" ]' v-for="(item,index) in checkedTagArr" :key="item+Math.random()">{{item}} <i class="el-icon-close"  @click="deleteItem(item)"></i></span>
      <!-- <el-input 
        ref="inputItem"
        class="custom-input"
        v-model.lazy="inputValue" 
        :placeholder="checkedTagArr.length>0 ?'' :placeholder"
        @input="handelInput"
        :maxlength="constraint.lengthMax"
        @keyup.enter.native="checkedContent" 
        @keyup.backspace.native="deleteLast"
        @focus="focus"
        @blur="blur"
      >
      </el-input> -->
      <input type="text"
        ref="inputItem"
        class="custom-input"
        v-model.lazy="inputValue" 
        :placeholder="checkedTagArr.length>0 ?'' :placeholder"
        @input="handelInput"
        :maxlength="constraint.lengthMax"
        @keyup.enter="checkedContent" 
        @keyup.backspace="deleteLast"
        @focus="focus"
        @blur="blur"
        @compositionstart="hasValue=false" 
        @compositionend="hasValue=true" />
    </span>
    <span v-if="contentShow" class="input-item-content" @click="checkedContent">{{inputValue}}</span>
    <i v-if="clearShow" class="clear-all el-icon-error"  @click="clearAllChecked"></i>
    <!-- <i v-if="clearShow" class="clear-all el-icon-error" @click="clearAllChecked"></i> -->
  </div>
</template>

<script>
import Clickoutside from '@/utils/clickoutside'
import isArray from "lodash/isArray";
import isEmpty from "lodash/isEmpty";
import isNil from "lodash/isNil";
import last from "lodash/last";

export default {
  props: ["value", "placeholder", "constraint"],
  data() {
    return {
      inputValue: null,
      contentShow: false,
      checkedTagArr: [],
      deleteFlag: false,
      deleteCount: 0,
      clearShow: false,
      focused: false,
      canDelete: true,
      passValidate: true,
      isEmpty: true, //判断输入法是
      hasValue: true
    };
  },
  directives: { Clickoutside },
  mounted() {
    if (!isNil(this.value)) {
      this.checkedTagArr = [...this.value];
    }
  },
  watch: {
    inputValue(val) {
      if (!val) {
        this.deleteCount = 0;
      }
    }
  },
  methods: {
    validator() {
      return this.checkedTagArr.length > 0 ? '' : '请填选必填项'
    },
    handelInput(e) {
      let event = window.event || e;
      let value = event.target.value;
      this.isEmpty = false;
      this.inputValue = value.trim();
      if (value && value.length > 0) {
        this.contentShow = true;
      } else {
        this.contentShow = false;
      }
    },
    checkedContent() {
      if (
        isArray(this.checkedTagArr) &&
        this.checkedTagArr.length >= this.constraint.countMax
      ) {
        this.inputValue = null;
        this.contentShow = false;
        return;
      }
      if (!this.inputValue) {
        return;
      } //修复报错信息
      const index = this.checkedTagArr.findIndex(el => el == this.inputValue);
      if (!isNil(this.inputValue || !this.inputValue.length <= 0)) {
        this.checkedTagArr.push(this.inputValue);
        this.clearShow = true;
      }
      //  if(index !==-1){
      //      this.checkedTagArr.splice(index,1)
      //      if(this.checkedTagArr.length<=0){
      //          this.clearShow=false;1
      //      }
      //  }else{
      //      if(!isNil(this.inputValue ||this.inputValue.length<=0)){
      //          this.checkedTagArr.push(this.inputValue);
      //          this.clearShow=true;
      //      }
      //  }
      this.inputValue = null;
      this.contentShow = false;
      this.$emit("change", this.checkedTagArr);
      if (this.checkedTagArr.length <= 0) {
        this.passValidate = false;
      } else {
        this.passValidate = true;
      }
      this.$emit("validateNode");
    },
    deleteItem(item) {
      const index = this.checkedTagArr.findIndex(el => el == item);
      this.checkedTagArr.splice(index, 1);
      if (this.checkedTagArr.length <= 0) {
        this.clearShow = false;
      }
      this.$emit("change", this.checkedTagArr);
    },
    deleteLast(event) {
      let e = event || window.event;
      // if (e.target.value == 0) {
      //   if (!this.isEmpty) {
      //     this.isEmpty = true;
      //   } else{
      //     if(!isEmpty(this.checkedTagArr)){
      //         this.checkedTagArr.pop();
      //         this.$emit('change',this.checkedTagArr);
      //         if(this.checkedTagArr.length==0){
      //           this.clearShow = false
      //         }
      //     }
      //   }
      // }
      if (this.hasValue && !this.inputValue) {
        if (this.deleteCount < 2) {
          this.deleteCount = this.deleteCount + 1;
        }
        if (this.deleteCount == 2) {
          // 删除标签
          if (!isEmpty(this.checkedTagArr)) {
            this.checkedTagArr.pop();
            this.$emit("change", this.checkedTagArr);
            if (this.checkedTagArr.length == 0) {
              this.clearShow = false;
            }
          }
          this.deleteCount = 2;
        }
      }

      // if(e.target.value.length == 0){
      //   if(this.canDelete && !isEmpty(this.checkedTagArr)){
      //     this.checkedTagArr.pop();
      //     if(isEmpty(this.checkedTagArr)){
      //       this.clearShow = false
      //     }
      //     this.$emit('change',this.checkedTagArr);
      //   }
      //   this.canDelete = true;
      // } else {
      //   this.canDelete = false;
      // }
    },
    closeMenu() {
      this.inputValue = null;
      this.contentShow = false;
      this.clearShow = false;
      this.focused = false;
    },
    clearAllChecked() {
      this.checkedTagArr = [];
      this.clearShow = false;
      this.$emit("change", []);
    },
    focus() {
      if (isArray(this.checkedTagArr) && this.checkedTagArr.length > 0) {
        this.clearShow = true;
      }
      this.focused = true;
      this.$emit("input-cv-focus", true);
    },
    blur() {
      this.$emit("input-cv-focus", false);
      if (this.checkedTagArr.length <= 0) {
        this.passValidate = false;
      } else {
        this.passValidate = true;
      }

      this.$emit("validateNode");
    },
    focusInput() {
      this.$refs.inputItem.focus();
    }
  },
  beforeDestroy() {
    // console.log('sdasd')
    // let input = document.querySelector('.custom-input')
    //   input.removeEventListener('compositionstart')
    //   input.removeEventListener('compositionend')
  }
};
</script>

<style lang='scss' scoped>
.input-item-box {
  //  min-width: 360px;
  //  max-width: 480px;
  //  display: inline-block;
  position: relative;
  //  width: 300px;
  //  border: 1px solid #dcdfe6;
  //  border-radius: 0 2px 2px 0;
  padding-right: 16px;
  .clear-all {
    position: absolute;
    top: 50%;
    right: 6px;
    font-size: 14px;
    color: #c0c4cc;
    transform: translateY(-50%);
    z-index: 1000;
    // display: none;
  }
}
.input-item-box-focus {
  // border: 1px solid #ff9052;
  // box-shadow: 0px 0px 8px 0px rgba(255, 144, 82, 0.4);
}
.input-item-box {
  //   padding-right: 16px;
}
.input-item-content {
  font-size: 12px;
  position: absolute;
  width: 100%;
  height: 28px;
  margin-top: 4px;
  cursor: pointer;
  line-height: 28px;
  background-color: #fff;
  top: 100%;
  left: 0;
  z-index: 1000;
  padding-left: 8px;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.5);
}
.input-item-content:hover {
  background-color: #f5f7fa;
}
.input-item-checked {
  font-size: 12px;
  height: 20px;
  border: 1px solid #ccc;
  border-color: transparent;
  background-color: #f2f2f2;
  display: inline-block;
  line-height: 20px;
  color: #595959;
  position: relative;
  border-radius: 4px;
  top: 1px;
  padding-left: 4px;
  padding-right: 2px;
  margin: 2px;
}
.inputitem-delete {
  border-color: #909399;
}

.input-item-content-box {
  display: flex;
  flex-wrap: wrap;
  .input-item-checked {
    white-space: nowrap;
    display: inline-block;
  }
  .el-input,
  .custom-input {
    flex: 1 1;
  }
}
.custom-input {
  font-size: 12px;
  padding: 0 8px;
  height: 26px;
  line-height: 26px;
  border: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #595959;
  display: inline-block;
  outline: 0;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
  /deep/ .el-input__inner {
    height: 26px;
    line-height: 26px;
    border: none;
  }
  &::placeholder {
    color: #bfbfbf;
  }
}
</style>
<style lang="scss">
.input-item-box {
  .el-input__inner {
    font-size: 12px;
    padding: 0 8px;
  }
}
</style>